import { Button, DialogTitle } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import DropZone from "../../../../commons/dropZone/DropZone";
import RequeridoLabel from "../../../../commons/labels/RequeridoLabel";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import { StyledEstablecimientos } from "../../../../styled/Prevencion";

const DialogAdjuntarFormulario = ({
  open,
  onClose,
  title,
  file,
  setFile,
  isAdjuntando,
  handleCancelClick,
  handleConfirmClick,
  isConfirmButtonDisabled,
}) => {
  const theme = useTheme();

  return (
    <StyledEstablecimientos.AdjuntarFormularioDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>{title}</DialogTitle>
      {isAdjuntando ? (
        <StyledEstablecimientos.LoadingContainer>
          <CircularLoading
            sx={{ color: theme.palette.tertiary.main }}
          />
          <RequeridoLabel text="Adjuntando el formulario..." />
        </StyledEstablecimientos.LoadingContainer>
      ) : (
        <>
          <DropZone
            file={file}
            setFile={setFile}
            loading={false}
            maxFiles={1}
            extension=".pdf"
            accept={{
              "application/pdf": [".pdf"],
            }}
            dropZoneText="Arrastre el formulario en formato .pdf aquí o haga click en el recuadro para
          adjuntarlo."
            dropZoneEditText="Si desea cambiar el archivo arrastrelo nuevamente o haga click en
          el recuadro."
          />
          <StyledEstablecimientos.ContainerButtonsDialog>
            <Button color="primary" type="button" onClick={handleCancelClick}>
              Cancelar
            </Button>
            <Button
              disabled={isConfirmButtonDisabled}
              color="primary"
              variant="contained"
              onClick={handleConfirmClick}
            >
              Confirmar
            </Button>
          </StyledEstablecimientos.ContainerButtonsDialog>
        </>
      )}
    </StyledEstablecimientos.AdjuntarFormularioDialog>
  );
};

export default DialogAdjuntarFormulario;
